import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import { gridSize } from '@atlaskit/theme/constants';
import { multiply } from '@atlaskit/theme/math';
import { h600 } from '@atlaskit/theme/typography';
/**
 * Provide a styled container for form sections.
 */
var FormSectionWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: ", "px;\n"], ["\n  margin-top: ", "px;\n"])), multiply(gridSize, 3));
/**
 * Provide a styled container for form section title
 */
var FormSectionTitle = styled.h3(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  line-height: ", "px;\n  margin-right: ", "px;\n  margin-top: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"], ["\n  ", ";\n  line-height: ", "px;\n  margin-right: ", "px;\n  margin-top: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"])), h600, multiply(gridSize, 4), multiply(gridSize, 4));
/**
 * Provide a styled container for form section content.
 */
var FormSectionDescription = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-top: ", "px;\n"], ["\n  margin-top: ", "px;\n"])), gridSize);
export default FormSectionWrapper;
export { FormSectionTitle, FormSectionDescription };
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=FormSection.js.map